import React, { useState } from 'react'
import { DialogSpin } from 'components'
import { Button } from '@mui/material'
import { useRevertUnbalanceMutation } from 'features'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features/snack-bar/snackSlice'
import { useOutletContext } from 'react-router-dom'

/**
 *
 * @param {*} _props
 * @returns
 */
export default function SetUnbalanceRevertDialog(_props) {
  const {
    togglerComponent: Component = { Button },
    children,
    togglerProps = {},
    rowData = {},
  } = _props
  const [open, setOpen] = useState(false)
  const { activeRow } = useOutletContext()
  const dispatch = useDispatch()

  function openDialog(e) {
    e.stopPropagation()
    setOpen(true)
  }
  function closeDialog() {
    setOpen(false)
  }
  const [revertTrans] = useRevertUnbalanceMutation()

  function handleSubmit(data) {
    if (data.nromov > 0) {
      const mutation = revertTrans({
        unbalanceid: activeRow.unbalanceid,
        nromov: data.nromov,
        txhash: rowData.txId,
      })
      mutation
        .then((response) => {
          if (response.data) {
            dispatch(
              successSnack({
                message: 'Quemado de activos revertido correctamente',
              })
            )
            closeDialog()
          } else if (response.error.data) {
            let message = ''
            switch (response.error.data.message) {
              case 'unbalance_not_found':
                message = 'No se encontró el desbalance'
                break
              case 'mov_not_user':
                message = 'El movimiento no cumple con los requerimientos'
                break
              default:
                message = 'Error al revertir el quemado de los activos'
                break
            }
            dispatch(
              errorSnack({
                message: message,
              })
            )
          }
        })
        .catch((error) => {
          dispatch(
            errorSnack({
              message: 'Error al revertir el quemado de los activos',
            })
          )
        })
    } else {
      dispatch(errorSnack({ message: 'El nro de movimiento es requerido' }))
    }
  }

  const message = `Ingresa el número de movimiento de quemado de activos. \n  El mismo debe ser de tipo liquidación, estar cancelado y tener un monto igual a ${rowData.ammount}`

  return (
    <>
      <Component onClick={openDialog} {...togglerProps}>
        {children}
      </Component>
      {open && (
        <DialogSpin
          open={open}
          handleClose={closeDialog}
          primaryButtonText="revertir" //Label of the primary button
          secondaryButtonText="Cancelar" // Label of the cancel button
          title={`Revertir quemado de Activos`} // 'Dialog title'
          message={message}
          onSubmit={handleSubmit} // Form submit action
          fields={[
            {
              name: 'nromov',
              helperText: `Introduzca el número de movimiento con el que desea relacionarlo`, // 'Dialog message'
              label: 'Movimiento',
              placeholder: '0',
              type: 'number',
              validation: {
                required: 'El Nro debe ser mayor a 0',
                min: {
                  value: 1,
                  message: 'El Nro debe ser mayor a 0',
                },
              },
            },
          ]}
          hasFields={true}
        />
      )}
    </>
  )
}
